var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.blok.content),function(blokChild){return _c(_vm.dashify(blokChild.component),{key:blokChild._uid,tag:"component",attrs:{"blok":blokChild}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }